var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('AppLabel',{attrs:{"label":"Given Name","value":_vm.details.givenName}}),_c('AppLabel',{attrs:{"label":"Surname","value":_vm.details.surname}}),_c('AppLabel',{attrs:{"label":"Email","value":_vm.details.email}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }